export default __webpack_public_path__ + "static/media/Card.1891cca3.svg";